import { Translation } from '@ps/web-shared-components';
import React, { useCallback } from 'react';
import { useForm } from 'react-final-form';

import StarsSquareIconButton from '@swf/components/StarsSquareIconButton/StarsSquareIconButton';

import Earth from '../../../../../../assets/icons/earth.svg';

import {
  TXTCLI_Other__choice,
  TXTWCL_You_are_a_citizen_of_a_differe_ELL
} from './OtherCitizenship.messages.json';
import { squareButton, text } from './OtherCitizenship.scss';

interface Props {
  active: boolean;
  handleClick(): void;
}

const OtherCitizenship: React.FC<Props> = ({ active, handleClick }) => {
  const form = useForm();

  const handleOtherChoiceClick = useCallback(() => {
    handleClick();
    form.change('nationalDocumentNumber', undefined);
    form.change('citizenship', undefined);
  }, [form, handleClick]);

  return (
    <StarsSquareIconButton
      Icon={Earth}
      active={active}
      colorActiveIcon={false}
      className={squareButton}
      groupTextClassName={text}
      dataTestId="other-choice"
      onClick={handleOtherChoiceClick}
      translation={{ tag: TXTCLI_Other__choice }}
      subTitle={<Translation tagName="small" {...TXTWCL_You_are_a_citizen_of_a_differe_ELL} />}
    />
  );
};
export default OtherCitizenship;
